'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'headset';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'f590';
var svgPathData = 'M49.1 204.2C58.9 116.3 133.5 48 224 48s165.1 68.3 174.9 156.2C385 196.4 369 192 352 192l-16 0c-26.5 0-48 21.5-48 48l0 96c0 26.5 21.5 48 48 48l16 0c17.5 0 33.9-4.7 48-12.8l0 20.9c0 39.8-32.3 72-72 72l-40 0 0 0c0-26.5-21.5-48-48-48l-32 0c-26.5 0-48 21.5-48 48s21.5 48 48 48c44 0 36 0 119.9 .1 66.3 0 120.1-53.7 120.1-120L448 224C448 100.3 347.7 0 224 0S0 100.3 0 224l0 64c0 53 43 96 96 96l16 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-16 0c-17 0-33 4.4-46.9 12.2zM352 240c26.5 0 48 21.5 48 48s-21.5 48-48 48l-16 0 0-96 16 0zM48 288c0-26.5 21.5-48 48-48l16 0 0 96-16 0c-26.5 0-48-21.5-48-48z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faHeadset = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;